"use client"

import LocalizedClientLink from "@modules/common/components/localized-client-link"
import { useEffect, useState } from "react"

const KEY = "amz_cookie_notice"

/**
 * Informative cookie notice. The shop only sets technical cookies, which do
 * not need consent (LSSI art. 22.2), so it just informs and can be closed.
 */
export default function CookieNotice() {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    try {
      setVisible(!localStorage.getItem(KEY))
    } catch {
      setVisible(false)
    }
  }, [])

  if (!visible) return null

  const close = () => {
    try {
      localStorage.setItem(KEY, "1")
    } catch {}
    setVisible(false)
  }

  return (
    <div
      role="region"
      aria-label="Aviso de cookies"
      className="fixed bottom-0 inset-x-0 z-[60] bg-amz-navy-light text-white text-xs small:text-sm px-4 py-3 flex flex-col small:flex-row items-center justify-center gap-3"
      data-testid="cookie-notice"
    >
      <p className="text-center">
        Solo usamos cookies tecnicas necesarias para la cesta, el inicio de sesion y el pago. No
        usamos cookies de analitica ni publicidad.{" "}
        <LocalizedClientLink href="/legal/cookies" className="underline">
          Mas informacion
        </LocalizedClientLink>
      </p>
      <button onClick={close} className="amz-btn-yellow px-6 py-1" data-testid="cookie-notice-close">
        Entendido
      </button>
    </div>
  )
}
